import { render, staticRenderFns } from "./modalAddOptIns.vue?vue&type=template&id=3832a23b&"
import script from "./modalAddOptIns.vue?vue&type=script&lang=js&"
export * from "./modalAddOptIns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports